import React from "react";
import Slider from "react-slick";
function SpaceRelax() {
  const imgSlide = [
    {
      name: "photo 1",
      url: "/images/room_image_4.png",
    },
    {
      name: "photo 2",
      url: "/images/room_image_6.png",
    },
    {
      name: "photo 3",
      url: "/images/room_image_7.png",
    },
    {
      name: "photo 4",
      url: "/images/room_image_8.png",
    },
    {
      name: "photo 5",
      url: "/images/room_image_9.jpg",
    },
  ];
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };
  return (
    <div className="spaceRelax">
      <img className="imgTablet" src="/images/tablet.png" alt="" />
      <div className="spaceRelaxBox">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5 className="title">Không gian đầy cảm hứng</h5>
            </div>

            <div className="col-12">
              <div className="spaceRelaxSlide">
                <Slider {...settings}>
                  {imgSlide.map((photo) => {
                    return (
                      <div className="item">
                        <img className="img-fluid" src={photo.url} alt="" />
                      </div>
                    );
                  })}
                </Slider>
              </div>
              <div className="spaceRelaxContent">
                <p>
                  Nằm trên giường và hưởng thụ mọi thiết bị thay đổi theo ý
                  thích.
                </p>
                <p>
                  Không gian âm thanh và ánh sáng thiết kế sẵn theo cảm xúc của
                  bạn.
                </p>
                <p className="textStyle">
                  <span>Tiệc tùng</span> , <span>Làm việc</span> hay{" "}
                  <span>Thư giãn</span> , bạn chọn đi!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SpaceRelax;
